import React from 'react';
import classNames from 'classnames';

import './WpSplitProgressBar.scss';

type Size = 'sm' | 'md';
const DEFAULT_SIZE = 'md';

export interface Props {
  /**
   * Size of the bar. Options: 'sm' | 'md'
   * @default 'md'
   */
  size?: Size;
  currentNumberStep: number;
  steps: Array<{
    stepNumber: number;
  }>;
}

const classNamePrefix = 'WpSplitProgressBar';

function WpSplitProgressBar({ size = DEFAULT_SIZE, currentNumberStep, steps }: Props) {
  const classes = classNames(classNamePrefix, `${classNamePrefix}--${size}`);

  return (
    <div className={classes}>
      {steps.map(({ stepNumber }) => (
        <div
          key={stepNumber}
          className={classNames(`${classNamePrefix}__step`, {
            [`${classNamePrefix}__step--completed`]: stepNumber <= currentNumberStep,
          })}
        />
      ))}
    </div>
  );
}

export default WpSplitProgressBar;
